import ActivityConfig from "./ActivityConfig";
import BasePlayer from "../utils/BasePlayer";

export default class ActivityPlayer extends BasePlayer {
  constructor(public config: ActivityConfig) {
    super(config);
  }
}
